import MultiStepBooleanWaterDisplay from './MultiStep/MultiStepWaterDisplay'
import MultiStepNumberDisplay from './MultiStep/MultiStepNumberDisplay'
import MultiStepBooleanDisplay from './MultiStep/MultiStepBooleanDisplay'
import StaticGauge from './StaticData'

const Gauge = {
  MultiStepBooleanWaterDisplay,
  MultiStepNumberDisplay,
  MultiStepBooleanDisplay,
  StaticGauge,
}

export default Gauge
